const opcjePaliwa = {
    t: 'Opcje paliwa', type: 'multi-checkbox', options: [
        'Paliwo E10',
        'Biodiesel',
        'Olej roślinny',
    ], names: [
        'paliwo-e10',
        'biodiesel',
        'olej-roslinny',
    ]
}

export default opcjePaliwa